<div class="task-details">
  <empty-details *ngIf="task.value.id === 0 && !editMode"
                 what="empty.what.task"></empty-details>

  <div *ngIf="task.value.id !== 0 || editMode" class="task-info-container">
    <div *ngIf="task.value.id !== 0 && !editMode" class="task-info">
      <table>
        <tr>
          <td>
            <strong>{{ "taskDetails.titleLabel" | translate }}:</strong>
          </td>
          <td>{{ task.value.title }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "taskDetails.remarkLabel" | translate }}:</strong>
          </td>
          <td>{{ task.value.remark }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "taskDetails.statusLabel" | translate }}:</strong>
          </td>
          <td class="dc">
            <dependent-choice
              [topic]="'status'"
              [selectedId]="task.value.status"
              [choiceObserver]="statusIdObserver"
              [labeler]="statusIdLabeler"
            ></dependent-choice>
          </td>
        </tr>
        <tr>
          <td>
            <strong>{{ "taskDetails.end_dateLabel" | translate }}:</strong>
          </td>
          <td>{{ task.value.end_date }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "taskDetails.taskTypeLabel" | translate }}:</strong>
          </td>
          <td>{{ task.value.task_type }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "taskDetails.executorLabel" | translate }}:</strong>
          </td>
          <td class="dc">
            <dependent-choice
              [topic]="'users'"
              [selectedId]="task.value.executor"
              [choiceObserver]="executorIdObserver"
              [labeler]="executorLabeler"
            ></dependent-choice>
          </td>
        </tr>
      </table>

      <div class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "taskDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteTask()">
          <span class="material-icons-outlined">delete</span>
          {{ "taskDetails.deleteButton" | translate }}
        </button>
      </div>
    </div>

    <form [formGroup]="taskForm" *ngIf="editMode">
      <div class="form-group">
        <label for="title">{{ "taskDetails.titleLabel" | translate }}:</label>
        <input type="text" id="title" formControlName="title" />
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="title"
        ></messages>
      </div>

      <div class="form-group">
        <label for="remark">{{ "taskDetails.remarkLabel" | translate }}:</label>
        <textarea id="remark" formControlName="remark"></textarea>
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="remark"
        ></messages>
      </div>

      <div class="form-group">
        <label for="status">{{ "taskDetails.statusLabel" | translate }}:</label>
        <single-choice
          formControlName="status"
          [completedUrl]="completionUrl"
          [topic]="'status'"
          [editMode]="editMode"
          [ticketId]="currentId"
          (choiceEvent)="relaySingleChoice($event)"
          [labeler]="statusIdLabeler"
          [choiceObserver]="statusIdObserver"
        ></single-choice>
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="status"
        ></messages>
      </div>
      <div class="form-group">
        <label for="task_type"
          >{{ "taskDetails.taskTypeLabel" | translate }}:</label
        >
        <input type="number" id="task_type" formControlName="task_type" />
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="taskType"
          [remap]="'task_type=taskType'"
        ></messages>
      </div>

      <div class="form-group">
        <label for="end_date"
          >{{ "taskDetails.end_dateLabel" | translate }}:</label
        >
        <input type="date" id="end_date" formControlName="end_date" />
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="end_date"
          [remap]="'end_date=endDate'"
        ></messages>
      </div>

      <div class="form-group">
        <label for="details"
          >{{ "taskDetails.detailsLabel" | translate }}:</label
        >
        <textarea id="details" formControlName="details"></textarea>
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="details"
        ></messages>
      </div>

      <div class="form-group">
        <label for="executor"
          >{{ "taskDetails.executorLabel" | translate }}:</label
        >
        <single-choice
          formControlName="executorId"
          [completedUrl]="completionUrl"
          [topic]="'users'"
          [editMode]="editMode"
          [ticketId]="currentId"
          (choiceEvent)="relaySingleChoice($event)"
          [labeler]="executorLabeler"
          [choiceObserver]="executorIdObserver"
        ></single-choice>
        <messages
          class="msg"
          [form]="taskForm"
          [messagesObserver]="messages"
          fieldname="executorId"
        ></messages>
      </div>

      <div class="action-buttons">
        <action-button
          class="btn-save"
          (actionEvent)="saveTask($event)"
          label="{{ 'taskDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "taskDetails.saveButton" | translate }}
        </action-button>

        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "taskDetails.cancelButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="taskForm"
        [messagesObserver]="messages"
        [remap]="'task_type=taskType'"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </form>
  </div>
</div>
